import React from 'react';
import { TextField} from '@material-ui/core';

interface PropertyAddressStepProps {
    address: string;
    addressError: boolean;
    city: string;
    cityError: boolean;
    state: string;
    stateError: boolean;
    zip: string;
    zipError: boolean;
    masterAddress: string;
    onAddressChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onCityChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onStateChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onZipChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onMasterAddressChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function PropertyAddressStep(props: PropertyAddressStepProps) {
    return (
        <div>
            <div style={{ display: "flex", marginTop: "15px" }}>
                <TextField 
                    error={props.addressError} 
                    helperText={props.addressError ? "**Required" : ""} 
                    style={{ width: "60%", marginLeft: "10%", marginRight: "12px" }} 
                    onChange={props.onAddressChange} 
                    value={props.address} 
                    id="address" 
                    label="Address" 
                />
                <TextField 
                    error={props.cityError} 
                    helperText={props.cityError ? "**Required" : ""} 
                    style={{ width: "140px", marginRight: "12px" }} 
                    onChange={props.onCityChange} 
                    value={props.city} 
                    id="city" 
                    label="City" 
                />
                <TextField 
                    error={props.stateError} 
                    helperText={props.stateError ? "Required" : ""} 
                    style={{ width: "50px", marginRight: "12px" }} 
                    onChange={props.onStateChange} 
                    value={props.state} 
                    id="state" 
                    label="State" 
                />
                <TextField 
                    error={props.zipError} 
                    helperText={props.zipError ? "**Required" : ""} 
                    style={{ width: "75px" }} 
                    onChange={props.onZipChange} 
                    value={props.zip} 
                    id="zip" 
                    label="Zip" 
                />
            </div>
            <div style={{ display: "flex", marginTop: "15px" }}>
                <TextField 
                    style={{ width: "60%", marginLeft: "10%" }} 
                    onChange={props.onMasterAddressChange} 
                    value={props.masterAddress} 
                    id="masterAddress" 
                    label="Master Address" 
                />
            </div>
        </div>
    );
}
